import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./SubscriptionCancel.css";

/**
 * /subscription/cancel — shown when the user closes/abandons Paddle checkout.
 * No charge was made; offer a path back to pricing or checkout retry.
 */
export default function SubscriptionCancel() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const plan = params.get("plan") || "pro";
  const billing = params.get("billing") || "monthly";

  return (
    <div data-testid="subscription-cancel-page" className="min-h-screen bg-neutral-950 text-neutral-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full rounded-2xl border border-neutral-700 bg-neutral-900 p-8 text-center rsc-subcancel-card">
        <div className="text-5xl mb-4">🛑</div>
        <h1 className="text-2xl font-semibold mb-3" data-testid="subscription-cancel-heading">
          Checkout cancelled
        </h1>
        <p className="text-neutral-400 text-sm mb-6" data-testid="subscription-cancel-note">
          No payment was made. You can restart checkout anytime — your free
          access is unaffected.
        </p>
        <div className="flex flex-col gap-3">
          <button
            type="button"
            data-testid="subscription-cancel-retry"
            onClick={() => nav(`/subscribe?plan=${plan}&billing=${billing}`)}
            className="w-full rounded-lg bg-amber-500 hover:bg-amber-400 text-neutral-950 font-semibold py-3 transition"
          >
            Try Again
          </button>
          <button
            type="button"
            data-testid="subscription-cancel-back-pricing"
            onClick={() => nav("/pricing")}
            className="w-full rounded-lg border border-neutral-700 bg-neutral-800 hover:bg-neutral-700 text-neutral-100 font-medium py-3 transition"
          >
            Back to Pricing
          </button>
        </div>
      </div>
    </div>
  );
}
